module.exports = __webpack_public_path__ + "img/laravel-dark.ed94d764.svg";